(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CommunicationStatusDeleteController',CommunicationStatusDeleteController);

    CommunicationStatusDeleteController.$inject = ['$uibModalInstance', 'entity', 'CommunicationStatus'];

    function CommunicationStatusDeleteController($uibModalInstance, entity, CommunicationStatus) {
        var vm = this;
        vm.communicationStatus = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            CommunicationStatus.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
